export default function(ptime, ctime){

    if (!ptime) return ''
    if(!ctime) ctime = Date.now();

    let ntime = new Date(ptime),
        seconds = Math.floor((ctime - ntime) / 1000),
        intervals = [Math.floor(seconds / 31536000), Math.floor(seconds / 2592000), Math.floor(seconds / 604800),
            Math.floor(seconds / 86400), Math.floor(seconds / 3600),Math.floor(seconds / 60)
        ],
        times = ['year', 'month', 'week', 'day', 'hr', 'min'],
        key, res;
    for (key in intervals) {
        if (intervals[key] > 1){
            res  = intervals[key] + ' ' + times[key] + 's ago';
            return res;
        }else if (intervals[key] === 1){
            res = intervals[key] + ' ' + times[key] + ' ago';
            return res;
        }
    }
    return 'few secs ago';
}